import {Icon} from '@components/@icons';
import classNames from 'classnames';
import {useVideoPlayer, useVideoPlayerState} from '../../useVideoPlayer';
import {VideoControlsItem} from '../Item/VideoControlsItem';
import styles from './VideoPlayButton.module.css';

export const VideoPlayButton = () => {
    const {playPause} = useVideoPlayer();

    const isPlaying = useVideoPlayerState(s => s.isPlaying);

    const handlePausePlay = () => {
        playPause();
    };

    return (
        <VideoControlsItem onClick={handlePausePlay}>
            <Icon
                name={isPlaying ? 'pause' : 'play'}
                color="var(--color-icon-player)"
                size={24}
                className={classNames({[styles.playIcon]: !isPlaying})}
            />
        </VideoControlsItem>
    );
};
